// Example presets with images, prompts and results
export const examplePresets = [
  {
    id: 1,
    name: 'Perfume in Nature',
    preview: 'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-photoshoot%2Fexample-perfume%2Fimage.jpg?alt=media&token=b2e7eb6f-dbec-460d-8700-e5807af544d1',
    prompt: 'Elegant perfume bottle on moss-covered stone in a misty forest',
    results: [
      '/images/example-perfume/results/result1.jpeg',
      '/images/example-perfume/results/result2.jpeg'
    ]
  },
  {
    id: 2,
    name: 'Studio Lighting',
    preview: 'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-photoshoot%2Fexample-shoes%2Fimage.jpg?alt=media&token=43579b87-4c0e-4827-9520-cfb75bedfb65',
    prompt: 'Shoes floating in air between clouds',
    results: [
      '/images/example-shoes/results/result1.jpeg',
      '/images/example-shoes/results/result2.jpeg'
    ]
  },
  {
    id: 3,
    name: 'Lifestyle Context',
    preview: 'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-photoshoot%2Fexample-facewash%2Fimage.jpg?alt=media&token=2ef954ed-6256-493b-b3dd-cd90f8a9fe29',
    prompt: 'kept in green grass',
    results: [
      '/images/example-facewash/results/result1.jpeg',
    ]
  }
];

export type ExamplePreset = typeof examplePresets[0]; 